/**
 * Okeydaş marka logosu. Boyut ve varyantlara göre uygun görsel dosyayı yükler.
 * variant: "full" (yatay logo + slogan) veya "mark" (kare/mini kullanım için)
 */
export default function Logo({ size = 48, variant = "full", className = "", testId }) {
  const src = "/brand/logo.png";
  const h = typeof size === "number" ? `${size}px` : size;
  if (variant === "mark") {
    // Küçük kare kullanım — logoyu daire içine sarıp altın çerçeve ekle
    return (
      <div
        className={`rounded-2xl brand-gradient border border-[hsl(var(--brand-gold))/0.4] tile-shadow flex items-center justify-center overflow-hidden ${className}`}
        style={{ height: h, width: h }}
        data-testid={testId}
      >
        <img
          src={src}
          alt="Okeydaş"
          className="h-[85%] w-auto object-contain"
          draggable={false}
        />
      </div>
    );
  }
  return (
    <img
      src={src}
      alt="Okeydaş"
      style={{ height: h, width: "auto" }}
      className={`select-none ${className}`}
      draggable={false}
      data-testid={testId}
    />
  );
}
